$(async () => {
  if (typeof dataLayer !== 'object') return;

  dataLayer.push({ criteoDeviceType: await getDeviceType() });

  // for CMS pages
  const products = $('a[data-catalog-item-id]')
    .map(function () {
      const $this = $(this);

      return {
        catalog_item_id: $this.data('catalog-item-id'),
        sku: $this.data('sku'),
      };
    })
    .get();

  if (products.length) {
    dataLayer.push({
      products,
    });
  }
});

// Loaded only on pages with Google Tag Manager, as its own chunk, rather than in every page's bundle.
async function getDeviceType() {
  const { default: MobileDetect } = await import('mobile-detect');
  const md = new MobileDetect(window.navigator.userAgent);

  return md.phone() || md.tablet() ? 'm' : 'd';
}
